import { appCardShadows, type AppShadowTokens } from "./shadows";
import { theme, type ThemeConfig } from "antd";

import { appBrandPalettes, appGrayPalettes, appNeutralPalette, darkBrandSeed } from "./palette";

const brand = appBrandPalettes.dark;
const neutral = Object.fromEntries(appNeutralPalette.map((color, index) => [`appNeutral${index + 1}`, color]));
const brandTokens = Object.fromEntries(brand.map((color, index) => [`appBrand${index + 1}`, color]));
const grayTokens = Object.fromEntries(appGrayPalettes.dark.map((color, index) => [`appGray${index}`, color]));

const token: ThemeConfig["token"] & AppShadowTokens = {
  ...appCardShadows.dark,
  ...neutral,
  ...brandTokens,
  ...grayTokens,
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  colorPrimary: darkBrandSeed,
  colorLink: darkBrandSeed,
  colorLinkHover: brand[6],
  colorBgLayout: neutral.appNeutral10,
  colorBgContainer: neutral.appNeutral9,
  colorBgElevated: neutral.appNeutral8,
  colorBorder: neutral.appNeutral7,
  colorBorderSecondary: neutral.appNeutral8,
  colorSplit: neutral.appNeutral7,
};

const darkBrandAlgorithm: typeof theme.darkAlgorithm = (seed, mapToken) => ({
  ...theme.darkAlgorithm(seed, mapToken),
  // Сохраняем штатную прозрачность базового цвета тени darkAlgorithm (20%).
  colorShadow: `${appBrandPalettes.light[0]}33`,
});

// Передаём исходный seed: готовый brand6 нельзя повторно пропускать через darkAlgorithm.
export const darkTheme: ThemeConfig = {
  algorithm: darkBrandAlgorithm,
  token,
  components: {
    Card: {
      headerBg: neutral.appNeutral9,
    },
    Layout: {
      headerBg: neutral.appNeutral9,
      headerPadding: "0 24px",
      siderBg: brand[0],
      triggerBg: brand[0],
      triggerColor: neutral.appNeutral2,
    },
    // Sidebar остаётся тёмным и использует тёмную brand-палитру.
    Menu: {
      activeBarBorderWidth: 0,
      collapsedIconSize: 18,
      collapsedWidth: 64,
      darkGroupTitleColor: neutral.appNeutral5,
      darkItemBg: brand[0],
      darkItemColor: neutral.appNeutral2,
      darkItemDisabledColor: neutral.appNeutral5,
      darkItemHoverBg: brand[1],
      darkItemHoverColor: neutral.appNeutral1,
      darkItemSelectedBg: brand[3],
      darkItemSelectedColor: neutral.appNeutral1,
      darkPopupBg: brand[0],
      darkSubMenuItemBg: brand[0],
      iconMarginInlineEnd: 12,
      iconSize: 18,
      itemHeight: 44,
      itemMarginInline: 12,
      subMenuItemBorderRadius: 8,
    },
    Select: {
      optionSelectedBg: brand[1],
      optionSelectedColor: brand[5],
      optionActiveBg: neutral.appNeutral7,
      controlItemBgActiveHover: brand[1],
    },
    Table: {
      filterDropdownBg: neutral.appNeutral8,
      filterDropdownMenuBg: neutral.appNeutral8,
    },
  },
};
